import { useQuery } from '@tanstack/react-query';
import { apiHelper } from '../lib/api';

export function useHrDashboard(orgId) {
  return useQuery({
    queryKey: ['dashboard', 'hr', orgId],
    queryFn: () => apiHelper.getResource('/hr/dashboard/hr/', { orgId }),
    enabled: !!orgId,
  });
}

export function useMeDashboard(orgId) {
  return useQuery({
    queryKey: ['dashboard', 'me', orgId],
    queryFn: () => apiHelper.getResource('/hr/dashboard/me/', orgId ? { orgId } : {}),
    enabled: !!orgId,
  });
}
